<template>
    <div>
        <avue-crud
                :option="option"
                :data="data"
                :page="page"
                @refresh-change="refreshChange"
                @search-change="searchChange"
                @row-save="store"
                @row-update="update"
                @row-del="del"
                @size-change="sizeChange"
                @current-change="currentChange"
                :upload-before="uploadBefore"
                ref="crud"
        >
            <template slot="menuLeft">
                <el-button size="small" type="success" icon="el-icon-download" @click="excelExport('用户列表', '工号,姓名,手机号,部门,TEAM,身份证号')">导出</el-button>
                <ExcelImport :model="'user'" :templateName="'user.xlsx'" @success="excelImportSuccess()"></ExcelImport>
            </template>
        </avue-crud>
    </div>
</template>
<script>
  import curd from './Base/Crud'
  import ExcelImport from "./PlugIn/ExcelImport";

  export default {
    mixins: [curd],
    components: {ExcelImport},
    data() {
      return {
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: true, // 增加按钮显隐
          addBtnText: '新增员工', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '工号',
              prop: 'id',
              span: 24,
              search: true,
              rules: [{
                required: true, message: '工号不能为空', trigger: 'blur'
              }]
            },
            {
              label: '用户名',
              prop: 'username',
              span: 24,
              search: true,
              rules: [{
                type: 'string', required: true, message: '用户名不能为空', trigger: 'blur'
              }]
            },
            {
              label: '手机号',
              prop: 'tel',
              search: true,
              span: 24,
              rules: [{
                type: 'string', required: true, message: '手机号不能为空', trigger: 'blur'
              }]
            },
            {
              label: '身份证号',
              prop: 'id_num',
              span: 24,
              rules: [{
                required: true, message: '身份证号不能为空', trigger: 'blur'
              }]
            },
            {
              label: '在职状态',
              prop: 'status',
              span: 24,
              addDisplay: false,
              type: 'select',
              dicData: [{'label': '在职', 'value': 1}, {'label': '离职', 'value': 2}]
            },
            {
              label: '部门',
              prop: 'class',
              span: 24,
            },
            {
              label: 'TEAM',
              overHidden: true,
              prop: 'team',
              span: 24
            },
            {
              label: '最新上线时间',
              overHidden: true,
              prop: 'last_login_time',
              display: false,
              span: 24
            }
          ]
        }
      }
    },
    methods: {
      handleOrder(row) {
        this.dialogOrderVisible = true;
        this.roomId = row.id;
      },
      handleImport(file) {
        let _that = this;
        this.$export.xlsx(file.raw)
          .then(data => {
            this.list = data.results;
            this.api.post(_that.config.baseURL + '/user/import', this.list).then((re) => {
                if (re && re.code === 0) {
                  this.initialization();
                  this.$message.success(re.msg);
                } else re && this.$message.error(re.msg || '网络错误');
              }
            )
          })
      }
    }
  }
</script>
